import { render, staticRenderFns } from "./SignInPC.vue?vue&type=template&id=14842888&scoped=true&"
import script from "./SignInPC.vue?vue&type=script&lang=js&"
export * from "./SignInPC.vue?vue&type=script&lang=js&"
import style0 from "./SignInPC.vue?vue&type=style&index=0&id=14842888&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14842888",
  null
  
)

export default component.exports